
<div class="contentWrapper">
    <div class="logo">
        <div class="Wrapper">
            <!-- <span>flowtrics</span> -->
            <a [routerLink]="'/'"><img src="../../../assets/images/logo/flowtrics_logo.png" alt=""></a>
        </div> 
    </div>   
    
    <div class="Wrapper">
        <h3>Thank you for your signature!</h3>
        <h5>Once all parties have signed, you'll be emailed a copy.</h5>
        <div class="emailImg">
            <img src="../../../assets/images/thanksEmail.png" alt="">
        </div>
        <h5>All of your documents are saved into your flowtrics account. <br> Click below to login to view and download</h5>
        <div>
            <a class="register" target="_blank" href="https://app.flowtrics.com/auth/portallogin"  mat-stroked-button color="primary"  type="button">Guest Portal</a>
        </div>
        
    </div> 
</div>


